export default "/images/d0d0baf78a832ac9b7517995daf2e76e.png";